module.exports = __webpack_public_path__ + "img/pos3-bg.ceaab6f6.jpg";